import { withSuspenseLazy } from 'react-with-suspense-lazy';

import { Loader } from '@components/Loader';
import { RoutesConfiguration } from '@components/RouterOutlet';
import { permissionsRoles } from '@config/permissions';

import { AboutRoutePaths } from '../routesPaths';

const About = withSuspenseLazy(
  () => import('./AboutPage'),
  Loader,
);

export const AboutRouteConfig: RoutesConfiguration = [
  {
    path: AboutRoutePaths.aboutRoot,
    component: About,
    permittedRoles: permissionsRoles.about,
  },
];
